<template>
  <section class="premium-tab">
    <div
      v-if="isEdit"
      class="abs-top-right">
      <v-button
        type="primary"
        plain
        size="small"
        @click="editClick">Edit Quote</v-button>
    </div>
    <h2>Premium & Coverage</h2>
    <template v-if="!isNewSME">
      <div class="box premium-box">
        <h2>Premium</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <!--          <span>Percentage</span>-->
            <span>Amount</span>
          </div>
          <div
            v-for="(item,index) in sidebarPremium"
            :key="'sude'+index"
            class="tr">
            <template v-if="item.item == 'MGM Discount'">
              <span>
                <div class="flex">
                  <span v-html="changeLineData(item.item)"></span>
                  <span
                    v-if="formData.code"
                    class="mg-l-8">{{formData.code}}</span>
                </div>
              </span>
              <span
              >{{ item.premium_str }}</span>
            </template>
            <template v-else>
              <span>{{item.item}}</span>
              <span>{{ item.premium_str }}</span>
            </template>
          </div>
        <!--        <div class="tr">-->
        <!--          <span>Basic Premium</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.pre_basic_prm | formatMoney(2, true) }}</span>-->
        <!--          &lt;!&ndash;          <span v-if="productId == 11">{{ formData.basic_prm | formatMoney(2, true) }}</span>&ndash;&gt;-->
        <!--          &lt;!&ndash;          <span v-else>{{ formData.pre_basic_prm | formatMoney(2, true) }}</span>&ndash;&gt;-->
        <!--        </div>-->
        <!--        <template  v-if="form.class_id==11&&extra_content_premium.length>0">-->
        <!--          <div-->
        <!--            v-for="(item,index) in extra_content_premium"-->
        <!--            :key="'extra'+index"-->
        <!--            class="tr">-->
        <!--            <span>{{item.name}}</span>-->
        <!--            <span>-</span>-->
        <!--            <span>{{item.content.premium  | formatMoney(2, true) }}</span>-->
        <!--            &lt;!&ndash; <span>{{ formData.base_prm | formatMoney(2, true) }}</span> &ndash;&gt;-->
        <!--          </div>-->
        <!--        </template>-->

        <!--        <div class="tr">-->
        <!--          <span>NCD</span>-->
        <!--          <span>{{ formData.ncd_pct }}%</span>-->
        <!--          <span>{{ formData.ncd_vl | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>MIB</span>-->
        <!--          <span>{{ formData.mib_pct }}%</span>-->
        <!--          <span>{{ formData.mib_vl | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>IA Levy</span>-->
        <!--          <span>{{ formData.ia_levy_pct }}%</span>-->
        <!--          <span>{{ formData.ia_levy_vl | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-if="productId == 15 && formData.ec_levy_pct > 0"-->
        <!--          class="tr">-->
        <!--          <span>EC Levy</span>-->
        <!--          <span>{{ formData.ec_levy_vl | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>Promo Discount</span>-->
        <!--          <span>{{ formData.promo_disc_pct }}%</span>-->
        <!--          <span>{{ formData.promo_disc_prm | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>Coupon: {{ formData.coupon_code }}</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.coupon_vl | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>MGM Discount</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.code_disc_prm | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>Manual Discount</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.spec_disc_prm | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!--        <div class="tr">-->
        <!--          <span>Admin Charge</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.handling_fee | formatMoney(2, true) }}</span>-->
        <!--        </div>-->

        <!--        <div class="tr">-->
        <!--          <span>Total Premium</span>-->
        <!--          <span>-</span>-->
        <!--          <span>{{ formData.amount | formatMoney(2, true) }}</span>-->
        <!--        </div>-->
        <!-- Adjustment Quote -->
        <!-- <div class="tr">
          <span>Paid</span>
          <span>-</span>
          <span>---- adjustment</span>
        </div>
        <div class="tr">
          <span>Premium Difference</span>
          <span>-</span>
          <span>----</span>
        </div> -->
        </div>
      </div>
      <!--    <div class="box">-->
      <!--      <h2>Coverage</h2>-->
      <!--      <div class="table">-->
      <!--        <div class="tr th">-->
      <!--          <span>Item</span>-->
      <!--          <span>Amount</span>-->
      <!--        </div>-->
      <!--        <div-->
      <!--          v-for="(inItem, index) in formData.coverage"-->
      <!--          :key="index"-->
      <!--          class="tr">-->
      <!--          <span>{{ inItem.item }}</span>-->
      <!--          <span>{{ inItem.premium }}</span>-->
      <!--        </div>-->
      <!--        &lt;!&ndash; <div class="tr">-->
      <!--          <span>TPPD(Third Party Property Damage)</span>-->
      <!--          <span>{{ formData.tppd_limit_amt | formatMoney(0) }}</span>-->
      <!--        </div>-->
      <!--        <div class="tr">-->
      <!--          <span>TPBI(Third Party Bodily Injury)</span>-->
      <!--          <span>{{ formData.tpbi_limit_amt | formatMoney(0) }}</span>-->
      <!--        </div> &ndash;&gt;-->
      <!--      </div>-->
      <!--    </div>-->
      <div class="box">
        <div
          v-for="(excessItem, excessIndex) in coverageList.items"
          :key="'coverage' + excessIndex">
          <div
            v-if="excessItem.sub_items.length>0"
            class="table">
            <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
            <div
              v-if="excessIndex==0"
              class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div
              v-for="(subItem, subIndex) in excessItem.sub_items"
              :key="'coverage-' + excessIndex + subIndex"
              class="tr">
              <span>{{ subItem.item }}</span>
              <span>{{ subItem.premium }}</span>
            </div>
          </div>
        </div>
        <template v-if="extra_content_premium.length>0">
          <h3 class="extra-title">Extra Benefits</h3>
          <div
            v-for="(excessItem, excessIndex) in extra_content_premium"
            :key="'ext' + excessIndex">
            <div
              class="table">
              <div
                class="tr ">
                <span>{{excessItem.name}}</span>
              </div>
              <div
                class="tr ">
                <span>coverage</span>
              </div>
              <div
                v-for="(subItem, subIndex) in excessItem.content.coverage"
                :key="'coverage-extra' + excessIndex + subIndex"
                class="tr">
                <span>{{ subItem.name }}</span>
                <span>{{ subItem.money }}</span>
              </div>
            </div>
          </div>
        </template>

      </div>
      <div class="box">
        <h2>Excess</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Amount</span>
          </div>
          <div
            v-for="(inItem, index) in excessList"
            :key="index"
            class="tr">
            <span>{{ inItem.item }}</span>
            <span>{{ inItem.premium }}</span>
          </div>
        <!-- <div class="tr">
          <span>Third Party Property Damage Excess</span>
          <span>{{ formData.tppd_ex | formatMoney(0) }}</span>
        </div>
        <div class="tr">
          <span>TPPD Young Driver Excess</span>
          <span>{{ formData.tppd_young_driver_ex | formatMoney(0) }}</span>
        </div>
        <div class="tr">
          <span>TPPD Inexperience Excess</span>
          <span>{{ formData.tppd_inexp_driver_ex | formatMoney(0) }}</span>
        </div>
        <div class="tr">
          <span>TPPD Unnamed Driver Excess</span>
          <span>{{ formData.tppd_unnamed_driver_ex | formatMoney(0) }}</span>
        </div>
        <div class="tr">
          <span>Remark</span>
          <span>{{ formData.remark }}</span>
        </div> -->
        </div>
      </div>
    </template>
    <template v-else>
      <sme-premium-coverage :form-data="form"></sme-premium-coverage>
    </template>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import SmePremiumCoverage from '../../../sme/components/premium-coverage'

export default {
  name: 'PremiumTab',
  components: {SmePremiumCoverage},
  mixins: [MixinFormat,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  computed: {
    sidebarPremium() {
      let {quote_coverage_list={}} =this.form||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    productId() {
      return this.form.product_id || 11
    },
    extra_content_premium(){
      let {extra_benefits_content={}} = this.form||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    excessList(){
      let {quote_coverage_list} = this.form||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items && items.length){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.form||{}
      let {coverage} = quote_coverage_list||{}
      return  coverage||{}
    },
    isEdit(){
      const {stts} = this.form
      return stts < 401
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = val
      }
    }
  },
  methods: {
    editClick() {
      this.$emit('edit')
    }
  }
}
</script>
<style lang="scss" scoped>
.premium-tab {
    position: relative;
    .box {
        margin-bottom: 10px;
    }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .extra-title{
    font-size: 16px;
  }
}
</style>
